<template>
  <div>
    <b-modal
      id="masterAttractionCompare"
      modal-class="modal-cover modal-attraction-compare"
      v-model="isVisible"
      hide-backdrop
      hide-footer
      content-class="shadow-lg modal-xl"
      centered
      scrollable
    >
      <section v-if="compareParams" :dir="isHebrew ? 'rtl' : 'ltr'">
        <div class="intro-block text-center mb-4">
          <p class="mb-2 intro-line font-weight-bold">
            {{ t('masterAttractionCompareIntroLine1') }}
          </p>
          <p class="mb-3 intro-line font-weight-bold">
            {{ t('masterAttractionCompareIntroLine2') }}
          </p>
          <p class="mb-1 intro-hint">
            {{ t('masterAttractionCompareIntroLine3') }}
          </p>
          <p class="mb-0 intro-hint">
            {{ t('masterAttractionCompareIntroLine4') }}
          </p>
        </div>
        <b-row class="compare-row">
          <b-col cols="12" md="6" class="compare-col mb-4 mb-md-0">
            <h4 class="column-heading font-weight-bold mb-1">
              {{ t('masterAttractionCompareMasterColumn') }}
            </h4>
            <p class="column-subtitle mb-3">
              {{ t('masterAttractionCompareMasterColumnHint') }}
            </p>
            <div class="compare-card">
              <attraction-compare-panel :attr="compareParams.masterAttraction" />
            </div>
          </b-col>
          <b-col cols="12" md="6" class="compare-col">
            <h4 class="column-heading font-weight-bold mb-1">
              {{ t('masterAttractionCompareRideColumn') }}
            </h4>
            <p class="column-subtitle mb-3">
              {{ t('masterAttractionCompareRideColumnHint') }}
            </p>
            <div class="compare-card">
              <attraction-compare-panel :attr="compareParams.attractionNew" />
            </div>
          </b-col>
        </b-row>

        <div class="decision-block mt-5 mb-3">
          <p class="decision-line">{{ t('masterAttractionCompareDecisionSubtitle') }}</p>
          <p class="decision-hint-line">
            {{ t('masterAttractionCompareDecisionHint') }}
            <span
              class="info-icon-wrap"
              @click.stop="toggleTooltip"
              @mouseenter="openTooltipHover"
              @mouseleave="closeTooltipHover"
            >
              <span class="info-icon">ℹ</span>
              <div v-if="showTooltip" class="info-tooltip">
                <div class="tooltip-item">
                  <strong>{{ t('masterAttractionCompareContinueRepo') }}</strong>
                  <p>{{ t('masterAttractionCompareTooltip1') }}</p>
                </div>
                <div class="tooltip-item">
                  <strong>{{ t('masterAttractionCompareUpdateBaseNow') }}</strong>
                  <p>{{ t('masterAttractionCompareTooltip2') }}</p>
                </div>
                <div class="tooltip-item">
                  <strong>{{ t('masterAttractionCompareRideOnlyShort') }}</strong>
                  <p>{{ t('masterAttractionCompareTooltip3') }}</p>
                </div>
              </div>
            </span>
          </p>
        </div>

        <div class="sticky-action-bar">
          <a
            class="trip-default-btn btn-sky"
            href="#"
            @click.prevent="directUpdateBase"
          >
            {{ t('masterAttractionCompareContinueRepo') }}
          </a>
          <a
            class="trip-default-btn btn-outline-sky"
            href="#"
            @click.prevent="editMasterAttraction"
          >
            {{ t('masterAttractionCompareUpdateBaseNow') }}
          </a>
          <a
            class="trip-default-btn btn-greey"
            href="#"
            @click.prevent="closeAndContinue"
          >
            {{ t('masterAttractionCompareRideOnly') }}
          </a>
        </div>
      </section>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { translationMixin } from '@/mixins/translationMixin';
import AttractionComparePanel from './AttractionComparePanel.vue';

export default {
  name: 'MasterAttractionCompareModal',
  props: ['value'],
  mixins: [translationMixin],
  components: {
    AttractionComparePanel,
  },
  data() {
    return {
      showTooltip: false,
    };
  },
  computed: {
    ...mapGetters(['inerModalParameters']),
    isVisible: {
      set(val) {
        this.$emit('input', val);
      },
      get() {
        return this.value;
      },
    },
    compareParams() {
      const p = this.inerModalParameters;
      if (!p || (p.masterAttraction == null && p.attractionNew == null)) {
        return null;
      }
      return p;
    },
  },
  mounted() {
    document.addEventListener('click', this.handleOutsideClick);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleOutsideClick);
  },
  methods: {
    ...mapActions([
      'showModal',
      'completeAttractionUpdateAfterMasterCompare',
      'openAttractionFromMasterCompare',
      'directUpdateMasterAttractionFromCompare',
    ]),
    toggleTooltip() {
      this.showTooltip = !this.showTooltip;
    },
    openTooltipHover() {
      if (!('ontouchstart' in window)) this.showTooltip = true;
    },
    closeTooltipHover() {
      if (!('ontouchstart' in window)) this.showTooltip = false;
    },
    handleOutsideClick() {
      this.showTooltip = false;
    },
    closeAndContinue() {
      const p = this.inerModalParameters;
      const rideId = p && p.rideId;
      this.showModal('');
      this.completeAttractionUpdateAfterMasterCompare({ rideId });
    },
    directUpdateBase() {
      const p = this.inerModalParameters;
      if (!p || !p.attractionNew) return;
      this.showModal('');
      this.directUpdateMasterAttractionFromCompare({
        rideId: p.rideId,
        attractionNew: p.attractionNew,
        masterAttraction: p.masterAttraction || null,
      });
    },
    editMasterAttraction() {
      const p = this.inerModalParameters;
      if (!p || !p.attractionNew) {
        return;
      }
      this.openAttractionFromMasterCompare({
        attractionNew: p.attractionNew,
        masterAttraction: p.masterAttraction || null,
      });
      this.$nextTick(() => {
        this.showModal('');
      });
    },
  },
};
</script>

<style>
/* Widen the modal on desktop screens */
@media (min-width: 992px) {
  .modal-attraction-compare .modal-dialog {
    max-width: 1400px;
    width: 92vw;
  }
}
</style>

<style scoped>
.intro-line {
  font-size: 18px;
  color: #1e1e1e;
}
.intro-hint {
  font-size: 16px;
  color: #444;
}
.column-heading {
  font-size: 17px;
  color: #333;
}
.column-subtitle {
  font-size: 15px;
  color: #555;
  line-height: 1.35;
  margin-bottom: 0;
}
.compare-card {
  border: 1px solid #e8e8e8;
  border-radius: 12px;
  padding: 16px 18px;
  background: #fafafa;
  min-height: 120px;
}

/* decision block */
.decision-block {
  text-align: center;
}
.decision-line {
  font-size: 15px;
  color: #444;
  line-height: 1.6;
  margin-bottom: 10px;
}
.decision-hint-line {
  font-size: 15px;
  color: #222;
  font-weight: 600;
  line-height: 1.6;
  margin-bottom: 0;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  justify-content: center;
}

/* info icon */
.info-icon-wrap {
  position: relative;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  flex-shrink: 0;
}
.info-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #07A0C3;
  color: #fff;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 1;
  user-select: none;
}

/* tooltip */
.info-tooltip {
  position: absolute;
  bottom: calc(100% + 10px);
  left: 50%;
  transform: translateX(-50%);
  width: 300px;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  box-shadow: 0 6px 20px rgba(0,0,0,0.13);
  padding: 14px 16px;
  z-index: 9999;
  text-align: start;
}
.info-tooltip::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 7px solid transparent;
  border-top-color: #fff;
}
.info-tooltip::before {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 8px solid transparent;
  border-top-color: #e0e0e0;
  margin-top: 1px;
}
.tooltip-item {
  margin-bottom: 10px;
}
.tooltip-item:last-child {
  margin-bottom: 0;
}
.tooltip-item strong {
  display: block;
  font-size: 13px;
  color: #1e1e1e;
  margin-bottom: 2px;
}
.tooltip-item p {
  font-size: 13px;
  color: #555;
  font-weight: 400;
  margin-bottom: 0;
  line-height: 1.5;
}

/* sticky action bar */
.sticky-action-bar {
  position: sticky;
  bottom: 0;
  background: #fff;
  border-top: 1px solid #e8e8e8;
  box-shadow: 0 -4px 14px rgba(0, 0, 0, 0.08);
  padding: 14px 0 10px;
  margin-top: 24px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: center;
}

/* buttons */
.sticky-action-bar .btn-outline-sky {
  background: transparent !important;
  border: 2px solid #07A0C3 !important;
  color: #07A0C3 !important;
}
.sticky-action-bar .btn-outline-sky:hover {
  background: rgba(7, 160, 195, 0.07) !important;
}
.sticky-action-bar .btn-greey {
  background: #68afc2 !important;
  border-color: #68afc2 !important;
}
.sticky-action-bar .btn-greey:hover {
  background: #579db0 !important;
  border-color: #579db0 !important;
}

.compare-row {
  margin-left: -8px;
  margin-right: -8px;
}
.compare-col {
  padding-left: 8px;
  padding-right: 8px;
}
[dir='ltr'] .compare-col {
  text-align: left;
}
[dir='ltr'] .compare-card {
  text-align: left;
}
.modal.modal-cover .modal-content,
.modal.modal-cover .modal-footer,
.modal.modal-cover .modal-header {
  border: none;
}
</style>
